import { createContext, useContext, type ReactNode } from 'react';

export interface WorkspaceAccountActions {
  capacity: string;
  displayName: string;
  email?: string;
  identityInHeader?: boolean;
  onSignOut: () => void;
}

const WorkspaceAccountContext = createContext<WorkspaceAccountActions | undefined>(undefined);

export function WorkspaceAccountProvider({ children, value }: { children: ReactNode; value: WorkspaceAccountActions }) {
  return <WorkspaceAccountContext.Provider value={value}>{children}</WorkspaceAccountContext.Provider>;
}

export function useWorkspaceAccount(): WorkspaceAccountActions | undefined {
  return useContext(WorkspaceAccountContext);
}

export function accountInitials(value: string): string {
  const words = value.trim().split(/\s+/).filter(Boolean);
  return `${words[0]?.[0] ?? 'A'}${words.length > 1 ? words.at(-1)?.[0] ?? '' : ''}`.toUpperCase();
}
